import * as types from 'ducks/types'
import { ActionType } from 'ducks/common'

import { PlaybookApplicationType, PlaybookType } from 'app/types'

type StateType = {
    sidePanelMode: 'metadata' | 'voiceOver'
    metadataChanged: boolean
    qgTitle: string
    qgDescription: string
    qgApplications: Array<PlaybookApplicationType>
    qgDeletedApps: Array<PlaybookApplicationType>
    qgNewTags: Array<string>
    qgDeletedTags: Array<string>
    qgTransition?: string
    commentsStatus?: PlaybookType['commentsStatus']
}

const initialState: StateType = {
    sidePanelMode: 'metadata',
    metadataChanged: false,
    qgTitle: '',
    qgDescription: '',
    qgApplications: [],
    qgDeletedApps: [],
    qgNewTags: [],
    qgDeletedTags: [],
    qgTransition: ''
}

export const qgMetadataReducer = (state = initialState, action: ActionType): StateType => {
    switch (action.type) {
        case types.SET_SIDE_PANEL_MODE: {
            return {
                ...state,
                sidePanelMode: action.payload
            }
        }

        case types.SET_QUICK_GUIDDE_METADATA: {
            return {
                ...initialState,
                ...action.payload
            }
        }

        case types.SET_QUICK_GUIDDE_TITLE: {
            return {
                ...state,
                qgTitle: action.payload,
                metadataChanged: true
            }
        }

        case types.SET_QUICK_GUIDDE_DESCRIPTION: {
            return {
                ...state,
                qgDescription: action.payload,
                metadataChanged: true
            }
        }

        case types.SET_QUICK_GUIDDE_APPLICATIONS: {
            const { qgApplications, qgDeletedApps } = action.payload
            return {
                ...state,
                qgApplications,
                qgDeletedApps,
                metadataChanged: true
            }
        }

        case types.SET_QUICK_GUIDDE_TAGS: {
            const { qgNewTags, qgDeletedTags } = action.payload
            return {
                ...state,
                qgNewTags,
                qgDeletedTags,
                metadataChanged: true
            }
        }

        case types.SET_TRANSITION: {
            return {
                ...state,
                qgTransition: action.payload,
                metadataChanged: true
            }
        }

        case types.SET_QUICK_GUIDDE_COMMENTS: {
            return {
                ...state,
                commentsStatus: action.payload
            }
        }

        default: {
            return state
        }
    }
}
